import Navbar from '../externals/Navbar';
import Hero from '../externals/Hero';
import Footer from '../externals/Footer';
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { useNavigate } from 'react-router';

function Results25(){

  const navigate = useNavigate();
  function showRequestedResults(event){

    switch(event.target.id)
    {
        case "EtapaI":
            window.open(require("../../docs/CN_2025_Etapa_I_Results.pdf"));
            break;
        
        case "EtapaII":
            window.open(require("../../docs/CN_2025_Etapa_II_Results.pdf"));
            break;

        case "EtapaIII":
            window.open(require("../../docs/CN_2025_Etapa_III_Results.pdf"));
            break;
        
        case "EtapaIV":
            window.open(require("../../docs/CN_2025_Etapa_IV_Results.pdf"));
            break;
      
        case "EtapaV":
            window.open(require("../../docs/CN_2025_OPEN_Single_Results.pdf"));
            break;

        case "EtapaVTeams":
            window.open(require("../../docs/CN_2025_OPEN_Teams_Results.pdf"));
            break;
            
        case "EtapaVI":
            window.open(require("../../docs/CN_2025_Etapa_VI_Results.pdf"));
            break;

        case "EtapaVII":
            window.open(require("../../docs/CN_2025_Etapa_VII_Results.pdf"));
            break;

        case "EtapaVIII":
            window.open(require("../../docs/CN_2025_Etapa_VIII_Results.pdf"));
            break;

        case "EtapaIX":
            window.open(require("../../docs/CN_2025_Etapa_IX_Results.pdf"));
            break;

        case "EtapaX":
            window.open(require("../../docs/CN_2025_Etapa_X_Results.pdf"));
            break;
            
        case "EtapaXI":
            window.open(require("../../docs/Cupa_Romaniei_2025_Results.pdf"));
            break;  

        case "EtapaXII":
            window.open(require("../../docs/Cupa_De_Iarna_2025_Results.pdf"));
            break; 

        case "Overall":
            window.open(require("../../docs/Overall_Results_11.10.2025.pdf"));
            break;
            
        default:
            break;
    }

}

function showLiveResults()
{
navigate('/Live');
}

function goToResultSearch()
{
    navigate('/Search Results');
}

  return(
    <div> 
        <Navbar />
        <Hero />
        <br></br>
        <br></br> 
            <div className='container text-center'>
            <div className="card shadow-lg text-left">
                      <div className="card-body">
                          
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaI' onClick={showRequestedResults}>Etapa I - Timisoara - 17, 18, 19 Ianuarie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaII' onClick={showRequestedResults}>Etapa II - Cluj-Napoca - 7, 8, 9 Februarie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaIII' onClick={showRequestedResults}>Etapa III - Cluj-Napoca - 21, 22, 23 Martie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaIV' onClick={showRequestedResults}>Etapa IV - Joita - 11, 12, 13 Aprilie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaV' onClick={showRequestedResults}>Etapa V Open Romania - Joita - 22, 23, 24, 25 Mai</button>
                            <br></br>
                              <br></br>
                            <button className='btn btn-light' id='EtapaVTeams' onClick={showRequestedResults}>Etapa V Open Romania TEAMS - Joita - 22, 23, 24, 25 Mai</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaVI' onClick={showRequestedResults}>Etapa VI - ArgusMag Timisoara - 12, 13, 14 Iunie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaVII' onClick={showRequestedResults}>Etapa VII - Joita - 3, 4, 5, 6 Iulie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaVIII' onClick={showRequestedResults}>Etapa VIII - Bucecea - 7, 8, 9 August</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaIX' onClick={showRequestedResults}>Etapa IX - Tactical Expert Timisoara - 11, 12, 13 Septembrie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaX' onClick={showRequestedResults}>Etapa X Finala - Joita - 9, 10, 11 Octombrie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaXI' onClick={showRequestedResults}>Cupa Romaniei - Cluj-Napoca - 13, 14, 15 Noiembrie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='EtapaXII' onClick={showRequestedResults}>Cupa De Iarna - Timisoara - 12, 13, 14 Decembrie</button>
                            <br></br>
                            <br></br>
                            <button className='btn btn-light' id='Overall' onClick={showRequestedResults}>Overall 2025</button>
                            
                           
                      </div>
              </div>
            </div>
      
        <br></br>   

        <Footer />
    </div>
    

);

}

export default Results25;